<template>
  <div class="row justify-content-start mb-2">
    <div class="col-md-12 col-sm-12">
      <h4>{{ $t('ManageSystemView.diagnosticIndicatorSettings') }}</h4>
    </div>
  </div>
  <FileExport :filename="this.exportFilename"
              :data="this.exportData">
  </FileExport>
  <div class="row justify-content-center">
    <div class="col-12">
      <table class="table table-bordered table-striped table-responsive">
        <thead>
        <tr>
          <th colspan="2">Id</th>
          <th>{{ $t('name') }}</th>
          <th>{{ $t('agroecoPrinciple') }}</th>
          <th>{{ $t('dimension') }}</th>
          <th style="width:120px;">{{ $t('weight') }}</th>
          <th>{{ $t('minimumValue') }}</th>
          <th>{{ $t('maximumValue') }}</th>
          <th style="width:110px;">{{ $t('actions') }}</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="indicator in indicators"
                  :key="indicator.id">
          <tr>
            <td>
              <a v-if="indicator.collapsed"
                 @click="indicator.collapsed = !indicator.collapsed">
                <i class="bi bi-chevron-right"></i>
              </a>
              <a v-if="!indicator.collapsed"
                 @click="indicator.collapsed = !indicator.collapsed">
                <i class="bi bi-chevron-down"></i>
              </a>
            </td>
            <td>
              <input type="text"
                     class="form-control form-control-sm"
                     style="width:50px;"
                     v-model="indicator.name"
                     :disabled="!indicator.editable"/>
            </td>
            <td>
              <input type="text"
                     style="width:150px;"
                     class="form-control form-control-sm"
                     v-model="indicator.description"
                     :disabled="!indicator.editable"/>
            </td>
            <td>
              <multiselect placeholder=""
                           v-model="indicator.principle"
                           :options="availablePrinciples"
                           :custom-label="selectLabel"
                           :multiple="false"
                           :searchable="true"
                           :close-on-select="true"
                           :show-labels="false"
                           :disabled="!indicator.editable"></multiselect>
            </td>
            <td>
              <multiselect placeholder=""
                           v-model="indicator.dimension"
                           :options="availableDimensions"
                           :custom-label="selectLabel"
                           :multiple="false"
                           :searchable="true"
                           :close-on-select="true"
                           :show-labels="false"
                           :disabled="!indicator.editable"></multiselect>
            </td>
            <td>
              <input type="number"
                     style="width:75px;"
                     v-model="indicator.weight_in_dimension"
                     min="0"
                     max="100"
                     :disabled="!indicator.editable"/>
              %
            </td>
            <td>
              <input type="number"
                     style="width:75px;"
                     v-model="indicator.minimum_value"
                     min="0"
                     max="100"
                     :disabled="!indicator.editable"/>
            </td>
            <td>
              <input type="number"
                     style="width:75px;"
                     v-model="indicator.maximum_value"
                     min="0"
                     max="100"
                     :disabled="!indicator.editable"/>
            </td>
            <td>
              <button class="m-1 btn btn-warning btn-sm"
                      v-if="!indicator.editable"
                      @click="indicator.editable = true">
                <i class="bi bi-pencil"></i> {{ $t('edit') }}
              </button>
              <button class="m-1 btn btn-success btn-sm"
                      v-if="indicator.editable"
                      @click="indicator.editable = false">
                <i class="bi bi-floppy"></i> {{ $t('save') }}
              </button>
              <button class="m-1 btn btn-danger btn-sm"
                      v-if="indicator.editable"
                      @click="deleteIndicator(indicator.id, indicator.description)">
                <i class="bi bi-trash"></i> {{ $t('delete') }}
              </button>
            </td>
          </tr>
          <tr v-if="!indicator.collapsed">
            <td colspan="9">
              <table class="table table-bordered table-striped table-responsive">
                <thead>
                <tr>
                  <th>Indicator Summary</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <textarea v-model="indicator.summary"
                              :disabled="!indicator.editable"
                              class="w-100"
                              style="min-height:150px;"></textarea>
                  </td>
                </tr>
                </tbody>
              </table>

              <table class="table table-bordered table-striped table-responsive">
                <thead>
                <tr>
                  <th rowspan="2">{{ $t('odkVariable') }}</th>
                  <th>{{ $t('odkValue') }}</th>
                  <th>Indicator Value</th>
                  <th style="width:50px;"></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="variable in indicator.odk_variables"
                          :key="variable.id">
                  <tr v-for="(odkResult, index) in variable.odk_results"
                      :key="index">
                    <template v-if="index===0">
                      <td class="text-start"
                          :rowspan="variable.odk_results.length">
                        <input type="text"
                               :disabled="!indicator.editable"
                               :value="variable.odk_reference"/>
                        <button class="btn btn-sm btn-success"
                                v-if="indicator.editable">
                          <i class="bi bi-plus-circle"></i>
                        </button>
                        <button class="btn btn-sm btn-danger"
                                v-if="indicator.editable">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </template>
                    <td>
                      <multiselect v-model="variable.odk_results[index]"
                                   :custom-label="valueSelectLabel"
                                   :options="availableValues"
                                   track-by="id"
                                   :multiple="false"
                                   :searchable="true"
                                   :close-on-select="true"
                                   :show-labels="false"
                                   :disabled="!indicator.editable">

                      </multiselect>
                    </td>
                    <td>
                      <input type="number"
                             :value="odkResult.indicator_value"
                             :disabled="!indicator.editable"
                             min="0.0"
                             max="1000.0"/>
                    </td>
                    <td>
                      <button v-if="indicator.editable"
                              class="m-1 btn btn-danger btn-sm">
                        <i class="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </td>
          </tr>
        </template>

        </tbody>
      </table>
    </div>
  </div>

</template>

<script>

import FileExport from "@/components/FileExport.vue";

import {
  flattenForSheet,
  getAllDiagnosticsDimensions,
  getAllDiagnosticsIndicators,
  getAllDiagnosticsPrinciples, getAllDiagnosticsValues
} from "@/utils";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      indicators: [],
      availableOdkReferences: [],
      availablePrinciples: [],
      availableDimensions: [],
      availableValues: [],
      exportFilename: "",
      exportData: "",
    }
  },
  components: {
    Multiselect,
    FileExport,
  },
  methods: {
    addIndicator(id) {

    },

    editIndicator(id) {

    },

    deleteIndicator(id, description) {
      if (confirm("Are you absolutely sure you want to delete indicator \"" + description + "\"?")) {
        this.indicators = this.indicators.filter()
        console.log("delete");
      }
    },

    selectLabel({id, name}) {
      return `${name}`;
    },

    valueSelectLabel({id, odk_value}) {
      return `${odk_value}`;
    }
  },
  async mounted() {
    let dimensionsResponse = await getAllDiagnosticsDimensions();
    if (dimensionsResponse.status === 200) {
      this.availableDimensions = dimensionsResponse.data;
    } else {
      this.message = dimensionsResponse.response.data.message
      this.messageType = "danger";
    }

    let principlesResponse = await getAllDiagnosticsPrinciples();
    if (principlesResponse.status === 200) {
      this.availablePrinciples = principlesResponse.data;
    } else {
      this.message = principlesResponse.response.data.message
      this.messageType = "danger";
    }

    let indicatorsResponse = await getAllDiagnosticsIndicators();
    if (indicatorsResponse.status === 200) {
      this.indicators = indicatorsResponse.data;
    } else {
      this.message = indicatorsResponse.response.data.message
      this.messageType = "danger";
    }

    let valuesResponse = await getAllDiagnosticsValues();
    if (valuesResponse.status === 200) {
      this.availableValues = valuesResponse.data;
    } else {
      this.message = valuesResponse.response.data.message
      this.messageType = "danger";
    }

    const date = new Date().toISOString().slice(0, 10);
    this.exportFilename = date + "-CANALLS-Diagnostics-Indicators";
    this.exportData = flattenForSheet(this.indicators);
  }
};

</script>


